import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from '@/modules/shared/components/ui/card'
import { priceFormatter } from '@/modules/shared/utils/formatter'

import type { SellerReportType } from '../types/seller-report.type'

type SellerCardProps = {
	sellerReport: SellerReportType
}

export function SellerCardComponent({ sellerReport }: SellerCardProps) {
	return (
		<Card>
			<CardHeader className="p-4">
				<CardTitle className="text-sm">
					{sellerReport.razaoSocialNome}
				</CardTitle>
			</CardHeader>
			<CardContent className="-mt-5 p-4">
				<div className="grid grid-cols-3 text-clip">
					<div>
						<p className="text-xs text-muted-foreground">Cota Anual</p>
						<p className="text-xs font-semibold">
							{priceFormatter.format(sellerReport.anual).replace('R$', '')}
						</p>
					</div>
					<div>
						<p className="text-xs text-muted-foreground">Cota Trimestral</p>
						<p className="text-xs font-semibold">
							{priceFormatter.format(sellerReport.trimestral).replace('R$', '')}
						</p>
					</div>
					<div>
						<p className="text-xs text-muted-foreground">Cota Mensal</p>
						<p className="text-xs font-semibold">
							{priceFormatter.format(sellerReport.mensal).replace('R$', '')}
						</p>
					</div>
					<div>
						<p className="text-xs text-muted-foreground">Vendas</p>
						<p className="text-xs font-semibold">
							{priceFormatter.format(sellerReport.vendas).replace('R$', '')}
						</p>
					</div>
					<div>
						<p className="text-xs text-muted-foreground">Desv</p>
						<p className="text-xs font-semibold">{sellerReport.desvio}</p>
					</div>
					<div>
						<p className="text-xs text-muted-foreground">Faturamento</p>
						<p className="text-xs font-semibold">
							{priceFormatter
								.format(sellerReport.faturamento)
								.replace('R$', '')}
						</p>
					</div>
					<div>
						<p className="text-xs text-muted-foreground">Part</p>
						<p className="text-xs font-semibold">{sellerReport.participacao}</p>
					</div>
				</div>
			</CardContent>
		</Card>
	)
}
